/** Comparison or alarm turned off. */
export const REPORT_VALUE_COMPARISON_TYPE_NONE = 0
/** Effectively the &gt; comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_HIGHERTHAN = 1
/** Effectively the &gt;= comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_HIGHERTHANOREQUAL = 2
/** Effectively the &lt; comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_LOWERTHAN = 3
/** Effectively the &lt;= comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_LOWERTHANOREQUAL = 4
/** Effectively the &gt;= and &gt;= comparison operators. */
export const REPORT_VALUE_COMPARISON_TYPE_BETWEEN = 5
/** Effectively the = comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_EQUAL = 6
/** Effectively the != comparison operator. */
export const REPORT_VALUE_COMPARISON_TYPE_NOTEQUAL = 7
/** Effectively the &lt; and/or &gt; comparison operator appropriately combined. */
export const REPORT_VALUE_COMPARISON_TYPE_NOTBETWEEN = 8
